import { useInfiniteAssetCategoryDataSource } from 'custom_hooks/data_hooks/data_source/assetCategoryDataSource';
import { useDrainDataSource } from 'custom_hooks/data_hooks/data_source/useDrainDataSource';
import { useEffect, useMemo } from 'react';
import { queryClient } from 'utils/query';

const queryKey = 'asset-categories';

export function useAssetCategories(assetTypeId: number | undefined) {
    const { results, isLoading, setFilter, refetch } = useDrainDataSource(
        useInfiniteAssetCategoryDataSource({
            name: queryKey,
            defaultSort: [{ field: 'Name', dir: 'asc' }],
            defaultFilter: { assetTypeId: assetTypeId ?? undefined },
            enabled: !!assetTypeId,
        }),
    );

    useEffect(() => {
        setFilter((current) => ({ ...current, assetTypeId }));
    }, [assetTypeId, setFilter]);

    const finalResults = useMemo(
        () => (!assetTypeId ? [] : results),
        [assetTypeId, results],
    );

    return { results: finalResults, isLoading, setFilter, refetch };
}

export function invalidateAssetCategories() {
    queryClient.invalidateQueries({
        queryKey: [queryKey],
    });
}
